import type { CardToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useCardTokens = (theme: Theme): CardToken => {
  const { color, borderRadius, elevation, component } = theme;
  const base = {
    elevation: elevation.surface,
    hoverElevation: elevation.low,
    borderRadius: borderRadius.xl,
    border: `1px solid ${color.outline}`,
    background: {
      color: color.surface,
    },
    text: {
      color: color.onSurface,
    },
  };

  return merge({}, base, component?.card) as CardToken;
};
